import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./StatusIndicator.module.css";

/**
 * Props:
 *  - active
 *  - error
 *  - default
 *  - working
 */
class StatusIndicator extends Component {
  render() {

    let connected_live = this.props.connected_live;
    let connecting_live = this.props.connecting_live;
    let disconnected_live = this.props.disconnected_live;
    let error_live = this.props.error_live;
    let indicatorProps = { none: "" };

    if(connected_live) {
        indicatorProps = { active: "" };
    } else if (connecting_live) {
        indicatorProps = { working: "" };
    } else if (disconnected_live) {
        indicatorProps = { none: "" };
    } else if (error_live) {
        indicatorProps = { error: "" };
    }

    return (
        <div className={styles.wrapper}>
          <span className={styles.live_span}>Live</span>
          <div className={styles.indicator} {...indicatorProps} />
        </div>
    );
  }
}

const mapStateToProps = state => ({
  connected_live: state.tickets.connected_live_tickets,
  connecting_live: state.tickets.connecting_live_tickets,
  disconnected_live: state.tickets.disconnected_live_tickets,
  error_live: state.tickets.error_live_tickets,
});

export default connect(mapStateToProps)(StatusIndicator)